import MagicLinkView from './MagicLinkView';

export default MagicLinkView;
